export default function Highlighter({
  isMultiLine,
  children,
}: {
  isMultiLine?: boolean;
  children: any;
}) {
  return (
    <div
      className={`${
        isMultiLine ? "p-4 w-full" : "pb-0.5 px-1 inline mx-0.5"
      } bg-promWhite2 rounded-sm text-sm`}
    >
      {children}
    </div>
  );
}
